import { isMacUserAgent } from '../user-agent.mjs';
import { KEYBOARD_SHORTCUT_COMBINATOR, GenericHotKey, KEYBOARD_SHORTCUT_COMBINATOR_REGEX } from './keys.mjs';
import { hasAltKeySymbol, hasControlKeySymbol, hasMetaKeySymbol, hasShiftKeySymbol, hasBackspaceKeySymbol, hasArrowUpKeySymbol, hasArrowDownKeySymbol, hasEnterKeySymbol, getAltKeySymbol, getControlKeySymbol, getMetaKeySymbol, getShiftKeySymbol, getArrowUpKeySymbol, getArrowDownKeySymbol, getEnterKeySymbol, getBackspaceKeySymbol } from './symbols.mjs';

function parseKeyboardShortcut(shortcut) {
  const keys = shortcut.split(KEYBOARD_SHORTCUT_COMBINATOR);
  return {
    key: keys[keys.length - 1],
    altKey: hasAltKeySymbol(keys),
    ctrlKey: hasControlKeySymbol(keys),
    metaKey: hasMetaKeySymbol(keys),
    shiftKey: hasShiftKeySymbol(keys),
    backspaceKey: hasBackspaceKeySymbol(keys),
    arrowUpKey: hasArrowUpKeySymbol(keys),
    arrowDownKey: hasArrowDownKeySymbol(keys),
    enterKey: hasEnterKeySymbol(keys)
  };
}
function isHotkey(event, shortcut) {
  const {
    key,
    altKey,
    ctrlKey,
    metaKey,
    shiftKey
  } = parseKeyboardShortcut(shortcut);
  return event.key.toLowerCase() === key.toLowerCase() && event.altKey === altKey && event.ctrlKey === ctrlKey && event.metaKey === metaKey && event.shiftKey === shiftKey;
}
function formatHotKeys(shortcut, options = {}) {
  const {
    forceMacControl = false
  } = options;
  const altKeySymbol = getAltKeySymbol();
  const controlKeySymbol = getControlKeySymbol(forceMacControl);
  const metaKeySymbol = getMetaKeySymbol();
  const shiftKeySymbol = getShiftKeySymbol();
  const arrowUpKeySymbol = getArrowUpKeySymbol();
  const arrowDownKeySymbol = getArrowDownKeySymbol();
  const enterKeySymbol = getEnterKeySymbol();
  const backspaceKeySymbol = getBackspaceKeySymbol();
  if (!altKeySymbol || !controlKeySymbol || !metaKeySymbol || !shiftKeySymbol || !arrowUpKeySymbol || !arrowDownKeySymbol || !enterKeySymbol || !backspaceKeySymbol) {
    return shortcut;
  }
  const formattedShortcut = shortcut.replace(GenericHotKey.Alt, altKeySymbol).replace(GenericHotKey.Control, controlKeySymbol).replace(GenericHotKey.Meta, metaKeySymbol).replace(GenericHotKey.Shift, shiftKeySymbol).replace(GenericHotKey.ArrowUp, arrowUpKeySymbol).replace(GenericHotKey.ArrowDown, arrowDownKeySymbol).replace(GenericHotKey.Enter, enterKeySymbol).replace(GenericHotKey.Backspace, backspaceKeySymbol);
  return isMacUserAgent() ? formattedShortcut.replace(KEYBOARD_SHORTCUT_COMBINATOR_REGEX, '') : formattedShortcut;
}

export { formatHotKeys, isHotkey, parseKeyboardShortcut };
